import timeFormatter from '@frontend/utils/timeFormatter'
import { ShiftPublishState } from '@frontend/graphql/types.generated'

import type { ShiftWithSlots } from '../shifts/types'

export type Coverage = {
  filled: number
  total: number
}

export type CoverState = 'empty' | 'partial' | 'full'

export const rosterCoverage = (shifts: ShiftWithSlots[]): Coverage =>
  shifts.reduce<Coverage>(
    (acc, shift) => ({
      filled: acc.filled + shift.shiftSlots.assignedCount,
      total: acc.total + shift.shiftSlots.totalCount,
    }),
    { filled: 0, total: 0 }
  )

export const draftShiftCount = (shifts: ShiftWithSlots[]): number =>
  shifts.filter((shift) => shift.publishState === ShiftPublishState.Draft).length

export const coveragePct = (filled: number, total: number): number =>
  total === 0 ? 0 : Math.round((filled / total) * 100)

export const coverState = (filled: number, total: number): CoverState => {
  if (total === 0) return 'full'
  if (filled === 0) return 'empty'
  if (filled >= total) return 'full'
  return 'partial'
}

const sortByStart = (a: ShiftWithSlots, b: ShiftWithSlots): number => {
  const aStart = new Date(a.startTime).getTime()
  const bStart = new Date(b.startTime).getTime()
  if (aStart !== bStart) return aStart - bStart
  return a.roleName.localeCompare(b.roleName)
}

export type ShiftDayGroup = {
  date: string
  shifts: ShiftWithSlots[]
}

export const groupShiftsByDay = (shifts: ShiftWithSlots[], dates: string[], zone?: string | null): ShiftDayGroup[] =>
  dates.map((date) => {
    const dayDateTime = timeFormatter.fromISO(date, zone).dateTime
    const shiftsForDay = shifts
      .filter((shift) => timeFormatter.fromISO(shift.startTime, zone).dateTime.hasSame(dayDateTime, 'day'))
      .sort(sortByStart)
    return { date, shifts: shiftsForDay }
  })
